import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    getDashboard(_, params) {
      return axios({
        url: `${process.env.VUE_APP_URL}/dashboard`,
        method: 'GET',
      })
    },
  },
}
